exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stores-region {\n  padding: 8px;\n}\n.stores-region__panel {\n  display: flex;\n  justify-content: space-between;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 2px;\n  color: #000000;\n}\n.stores-region__panel__edit {\n  display: flex;\n  align-items: center;\n  width: 30%;\n  font-size: 24px;\n  justify-content: space-between;\n}\n.stores-region-cities {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.stores-region-cities__item {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 38px;\n  color: #000000;\n}\n.stores-region-cities__item__edit {\n  width: 30%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.stores-region-cities__item :hover {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Stores/components/Region/Region.less
// module id = 920
// module chunks = 0